import { GridFilterInputMultipleValueProps } from "@mui/x-data-grid-pro";
import { AbstractEventAnalyticsLabel } from "../../store";
import FilterSelect, { FilterSelectProps } from "./FilterSelect";

function FilterMultipleSelect<T extends AbstractEventAnalyticsLabel>(props: GridFilterInputMultipleValueProps) {
  let value = props.item.value;

  if (!Array.isArray(value) ) {
    if (value) {
      value = [value];
    } else {
      value  = [];
    }
  }
  props.item.value = value;
  return <FilterSelect<T> {...props as FilterSelectProps<T>} multiple={true} />;
}

export default FilterMultipleSelect;
